export enum ExportType {
    CSV = 'CSV',
    PDF = 'PDF'
}
